// Activity pricing: readable summaries of ticket type rules (pricetier minage / maxage, mincount /
// maxcount, requires_pricetier_id / requires_ratio, dependents_max). Used by the price tier list of
// the settings and of a product.
export default {
  methods: {
    pricetierAgeText (pricetier) {
      const hasMin = pricetier && pricetier.minage !== null && pricetier.minage !== undefined && pricetier.minage !== ''
      const hasMax = pricetier && pricetier.maxage !== null && pricetier.maxage !== undefined && pricetier.maxage !== ''
      if (hasMin && hasMax) {
        return pricetier.minage + '–' + pricetier.maxage
      }
      if (hasMin) {
        return pricetier.minage + '+'
      }
      if (hasMax) {
        return '0–' + pricetier.maxage
      }
      return ''
    },
    /**
     * "Age 4–14 · Quantity 1–4 · Requires Adults (max 2 per one)", empty without rules.
     * tiers: all price tiers, for the name of the required one. withAge: false when the age is shown
     * elsewhere (the settings list has a column of its own).
     */
    pricetierRuleText (pricetier, tiers, withAge = true) {
      if (!pricetier) {
        return ''
      }
      const parts = []
      const age = withAge ? this.pricetierAgeText(pricetier) : ''
      if (age) {
        parts.push(this._('Age') + ' ' + age)
      }
      if (parseInt(pricetier.mincount) || parseInt(pricetier.maxcount)) {
        parts.push(this._('Quantity') + ' ' + (parseInt(pricetier.mincount) || 0) + '–' + (parseInt(pricetier.maxcount) || '∞'))
      }
      if (parseInt(pricetier.requires_pricetier_id)) {
        const required = (tiers || []).find(t => parseInt(t.id) === parseInt(pricetier.requires_pricetier_id))
        parts.push(this._('Requires') + ' ' + (required ? required.name : pricetier.requires_pricetier_id) + (parseInt(pricetier.requires_ratio) ? ' (' + this._('max %s per one').replace('%s', pricetier.requires_ratio) + ')' : ''))
      }
      if (parseInt(pricetier.dependents_max)) {
        parts.push(this._('Max %s dependents each').replace('%s', pricetier.dependents_max))
      }
      return parts.join(' · ')
    },
    // GetYourGuide: traveller category of a price tier ('' = none)
    gygCategoryOptions () {
      return [
        { value: '', name: this._('No category') },
        { value: 'ADULT', name: this._('Adult') },
        { value: 'CHILD', name: this._('Child') },
        { value: 'YOUTH', name: this._('Youth') },
        { value: 'INFANT', name: this._('Infant') },
        { value: 'SENIOR', name: this._('Senior') },
        { value: 'STUDENT', name: this._('Student') },
        { value: 'EU_CITIZEN', name: this._('EU citizen') },
        { value: 'MILITARY', name: this._('Military') },
        { value: 'EU_CITIZEN_STUDENT', name: this._('EU citizen student') }
      ]
    },
    gygCategoryLabel (category) {
      if (!category) {
        return ''
      }
      const option = this.gygCategoryOptions().find(o => o.value === category)
      return option ? option.name : category
    },
    // Initial suggestion from the age range: 0-2 infant, 3-14 child, 15-17 youth, 65+ senior, otherwise adult
    suggestGygCategory (pricetier) {
      const min = pricetier ? parseInt(pricetier.minage) : NaN
      const max = pricetier ? parseInt(pricetier.maxage) : NaN
      if (!isNaN(min) && min >= 65) {
        return 'SENIOR'
      }
      if (!isNaN(max)) {
        if (max <= 2) {
          return 'INFANT'
        }
        if (max <= 14) {
          return 'CHILD'
        }
        if (max <= 17) {
          return 'YOUTH'
        }
      }
      return 'ADULT'
    }
  }
}
